import React, { useEffect } from 'react';
import { useRef } from 'react';
import { useTheme } from '../theming/default_theme';
import Greeting from './Greeting';
import { get } from '../api/apiService';
import * as XLSX from 'xlsx';
import { apiEndPoints } from '../api/apiEndPoints';
import saveAs from 'file-saver';
import { convertDateFormat, formatDate } from '../utils/dateUtils';
import { useNavigate } from 'react-router-dom';
import ambassador_notfound from '../assets/icons/ambassasdors-not-found.png'

interface VisionAmbassadorsProps {
    showModal: boolean,
    setShowModal: (value: boolean) => void,
    menuSelected: string
}


const VisionAmbassadors: React.FC<VisionAmbassadorsProps> = ({ showModal, setShowModal, menuSelected }) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const [ambassatorsDataList, setAmbassatorDataList] = React.useState<any[]>([]);
    const [loading, setLoading] = React.useState(false);
    const [pageCount, setPageCount] = React.useState(1);
    const [pageCountIndex, setPageCountIndex] = React.useState(0);
    const [countPerPage, setCountPerPage] = React.useState(5);
    const [searchText, setSearchText] = React.useState('');
    const [totalPages, setTotalPages] = React.useState(0);
    const [selectedCities, setSelectedCities] = React.useState<string[]>([]);
    const [selectedServices, setSelectedServices] = React.useState<string[]>([]);
    const [isFilterApplyClicked, setIsFilterApplyClicked] = React.useState(false);
    const [urlRequestParameters, seturlRequestParameters] = React.useState<string>('');
    const tableRef = useRef<HTMLTableElement | null>(null);

    useEffect(() => {
        let urlRequestParameters = `?page=${pageCount + pageCountIndex - 1}&size=${countPerPage}&searchString=${searchText.trim()}`;
        urlRequestParameters += `&createdAt,id,desc`;
        seturlRequestParameters(urlRequestParameters);
    }, [showModal, pageCount, pageCountIndex, countPerPage, isFilterApplyClicked, searchText]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const url = `${apiEndPoints.visionAmbassadorsURL}?page=${pageCount + pageCountIndex - 1}&size=${countPerPage}&searchString=${searchText.trim()}&sort=createdAt,id,desc`;
                console.log('API URL:', url);
                const response = await get(url);
                console.log('API Response:', response);
                const typedResponse = response as { content: any[]; totalPages: number };
                setAmbassatorDataList(typedResponse.content || []);
                setTotalPages(response.totalPages || 0);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error);
                setLoading(false);
            }
        };
    
        fetchData();
    }, [pageCount, pageCountIndex, countPerPage, searchText]);

    useEffect(() => {
        setPageCount(1);
        setPageCountIndex(0);
    }, [searchText]);


    const handleAmbassatorClick = (ambassador: { _id: string;[key: string]: any }) => {
        console.log('ambassator_id:', ambassador.id);
        navigate(`/Landingpage/VisionAmbassadorDetailsPage/${ambassador.id}`, { state: { ambassador } });
    }

    const handleSearchTextChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const searchText = event.target.value;
        console.log('Search Text:', searchText);
        setSearchText(event.target.value);
        setPageCount(1);
        setPageCountIndex(0);
    }

    const handlePaginationChange = async (event: React.MouseEvent<HTMLDivElement>) => {
        const page = event.currentTarget.innerText.trim();
        console.log('Clicked Page:', page);
    
        if (page.includes('Prev')) {
            if (pageCount === 1 && pageCountIndex === 0) {
                return; // Already on the first page
            }
    
            if (pageCountIndex === 0) {
                setPageCount((prevPageCount) => prevPageCount - 5);
                setPageCountIndex(4);
            } else {
                setPageCountIndex((prevPageCountIndex) => prevPageCountIndex - 1);
            }
        } else if (page.includes('Next')) {
            if (pageCountIndex === 4) {
                setPageCount((prevPageCount) => prevPageCount + 5);
                setPageCountIndex(0);
            } else {
                setPageCountIndex((prevPageCountIndex) => prevPageCountIndex + 1);
            }
        } else {
            const pageIndex = parseInt(page, 10) - 1; // Convert to zero-based index
            setPageCount(Math.floor(pageIndex / 5) * 5 + 1);
            setPageCountIndex(pageIndex % 5);
        }
    };

    const exportTableToExcel = () => {
        const tableElement = tableRef.current;

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.table_to_sheet(tableElement);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Ambassadors List');

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(dataBlob, 'vision_ambassators_list.xlsx');
    }

    return (
        <div className="flex flex-col h-full w-full border border-2 mt-2 overflow-hidden" style={{ backgroundColor: theme.colors.background }}>
            <Greeting />
            <div className="flex flex-row items-center pb-5">
                <div className="flex  flex-row justify-start items-center ml-[24px] mr-[20%]">Vision Ambassadors</div>
                <input type="text" placeholder="Name, City" className={`flex flex-row justify-end h-10 w-[50%] border border-[${theme.colors.surface}] rounded-full text-black pl-[10px] mr-10 placeholder:text-sm`}
                    onChange={
                        handleSearchTextChange
                    }
                />
                <div className={`flex items-center justify-center w-12 h-12 rounded-lg mr-2 ${(ambassatorsDataList && ambassatorsDataList.length > 0) ? 'cursor-pointer' : 'grayscale opacity-50 pointer-events-none'} transition`}
                    onClick={exportTableToExcel}
                >
                    <img src="/download.png" alt="download" className="w-12 h-12" />
                </div>
            </div>
            <div className={`flex  justify-start items-center ml-[24px]  w-[96%] h-full overflow-hidden`}>
                {(((pageCount + pageCountIndex) != 1) || (ambassatorsDataList && ambassatorsDataList.length > 0)) ? (
                    <div className="flex flex-col w-full h-full">
                        <div
                            className={`flex justify-center items-center w-full h-[50%] border border-2 border-[${theme.borders.greyBorder}] rounded-[16px]`}
                            style={{
                                // overflowY: 'scroll',
                                overflowX: 'hidden',
                                borderRadius: 16,
                                background: 'inherit',
                                // boxSizing: 'content-box',
                                backgroundColor: theme.colors.secondary,
                                justifyItems: "start",
                                alignItems: "start"
                            }}
                        >
                            <table ref={tableRef} className="table-fixed h-full text-start border border-1" style={{ width: "100%", height: "100%", justifyItems: "start", alignItems: "start", justifyContent: "left", textAlign: 'left', fontFamily: theme.typography.fontFamily, fontWeight: theme.typography.fontWeightBold, fontSize: theme.typography.fontSize, color: theme.colors.text, borderRadius: 16, background: 'inherit' }}>
                                <thead className="w-full  font-bold bg-[#F9F7ED] border border-1" style={{ borderBottomColor: theme.borders.color }}>
                                    <tr>
                                        <th className="w-[28%] text-start px-4 py-2">Vision Ambassador</th>
                                        <th className="w-[18%] text-start px-4 py-2">City & State</th>
                                        <th className="w-[18%] text-start px-4 py-2">Contact Number</th>
                                        <th className="w-[20%] text-start px-4 py-2">Joined On</th>
                                        <th className="w-[10%] text-center px-4 py-2">Total Referrals</th>
                                    </tr>
                                </thead>
                                <tbody
                                    className={`w-full text-start border border-[${theme.borders.color}] align-top`}
                                    style={{ borderBottomColor: theme.borders.color, verticalAlign: 'top' }}
                                >
                                    {ambassatorsDataList.map((ambassador: any, index: number) => (
                                        <tr
                                            key={index}
                                            className={`w-full text-start border border:theme.borders.color cursor-pointer`}
                                            onClick={() => handleAmbassatorClick(ambassador)}
                                        >
                                            <td className="w-[28%] h-[10%] px-4 py-2 text-start">{`${ambassador?.userDetails?.firstName} ${ambassador?.userDetails?.lastName}`}</td>
                                            <td className="w-[18%] h-[10%] px-4 py-2 text-start">
                                                {ambassador?.userDetails?.city || ambassador.userDetails?.state
                                                    ? `${ambassador?.userDetails?.city ?? ''}${ambassador?.userDetails?.city && ambassador?.userDetails?.state ? ', ' : ''}${ambassador?.userDetails?.state ?? ''}`
                                                    : ''}
                                            </td>
                                            <td className="w-[18%] h-[10%] px-4 py-2 text-start">{ambassador?.userDetails?.phoneNumber ?? ''}</td>
                                            <td className="w-[20%] h-[10%] px-4 py-2 text-start">{ambassador?.userDetails?.createdAt ? convertDateFormat(ambassador?.userDetails?.createdAt) : ''}</td>
                                            <td className="w-[20%] h-[10%] px-4 py-2 text-center">{ambassador?.patientCount ?? ''}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                        </div>
                        {/* {showFilter && <FilterHospitalSideBar setShowFilter={setShowFilter} showFilter={showFilter} hospitalList={hospitalList} allHospitals={allHospitals} setAllHospitals={setAllHospitals} selectedCities={selectedCities} setSelectedCities={setSelectedCities} selectedServices={selectedServices} setSelectedServices={setSelectedServices} setIsFilterApplyClicked={setIsFilterApplyClicked}/> } */}
                        <div className="flex flex-row items-center mt-10 gap-x-10 w-[30%] h-[10%] ml-[30%] justify-between">
                            {/* Previous Button */}
                            <div
                                className={`${(pageCount + pageCountIndex - 1) != 0
                                    ? 'flex items-center cursor-pointer'
                                    : 'flex items-center pointer-events-none opacity-50 cursor-not-allowed'
                                    }`}
                                onClick={(pageCount + pageCountIndex - 1) != 0 ? handlePaginationChange : undefined}
                            >
                                &laquo;Prev
                            </div>

                            {/* Page Numbers */}
                            {[...Array(5)].map((_, i) => {
                                const pageNumber = pageCount + i;
                                const isActive = i === pageCountIndex;
                                const isDisabled = pageNumber > totalPages; // Disable if the page number exceeds total pages
                                return (
                                    <div
                                        key={pageNumber}
                                        className={`flex items-center px-4 py-2 ${isActive
                                            ? 'bg-[#102A83] text-white rounded-full'
                                            : 'text-[#102A83]'
                                            } ${isDisabled ? 'pointer-events-none opacity-50 cursor-not-allowed' : 'cursor-pointer'
                                            }`}
                                        onClick={!isDisabled ? handlePaginationChange : undefined}
                                    >
                                        {pageNumber}
                                    </div>
                                );
                            })}

                            {/* Next Button */}
                            <div
                                className={`${(pageCount + 5 <= totalPages)
                                    ? 'flex items-center cursor-pointer'
                                    : 'flex items-center pointer-events-none opacity-50 cursor-not-allowed'
                                    }`}
                                onClick={(pageCount + 5 <= totalPages) ? handlePaginationChange : undefined}
                            >
                                <span>Next&raquo;</span>
                            </div>
                        </div>
                    </div>

                ) : (
                    <div className="flex flex-col justify-center items-center w-full h-full">
                        <div className="flex flex-col w-[50%] h-auto justify-center items-center overflow-visible rounded-[16px]">
                            <img
                                src={ambassador_notfound}
                                alt="ambassador_notfound"
                                className="w-full h-auto object-contain"
                            />
                        </div>
                    </div>
                )}



            </div>

            {/* {showFilter && <FilterHospitalSideBar setShowFilter={setShowFilter} showFilter={showFilter} hospitalList={hospitalList} allHospitals={allHospitals} setAllHospitals={setAllHospitals} selectedCities={selectedCities} setSelectedCities={setSelectedCities} selectedServices={selectedServices} setSelectedServices={setSelectedServices} setIsFilterApplyClicked={setIsFilterApplyClicked}/> } */}
        </div>

    );
}

export default VisionAmbassadors;